import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Menu/MenuAnatomy.mdx";
import Usage from "../../Docs/Components/Menu/MenuUsage.mdx";

import Examples from "../../Docs/Components/Menu/MenuExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Menu"
            description="Menus represent a list of options or items users can choose from."
            apiSources={["azure-devops-ui/Components/Menu/Menu.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;